export default __webpack_public_path__ + "static/media/mindy_branding_2.6a1d7771.svg";